import { Button, MenuItem, Select, Stack, TextField } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatesPicker from 'src/components/mui/datespicker';
import { boxStyle, MenuFilter, menuStyle } from './MenuStyle';

const MenuMember = props => {
    const { setFilters, setReload } = props;

    const locations = ['서울', '부산', '대구', '인천', '광주', '대전', '울산', '세종', '경기', '충북', '전남', '경북', '경남', '강원', '전북', '제주'];
    const attribs = ['일반', '임시'];
    const fields = ['국가연구소', '제조업', '학교', '도소매'];
    const deals = ['거래고객', '잠재고객', '기타'];
    const grades = ['S', 'A', 'B', 'C', 'D', 'E', 'F'];

    const [ranges, setRanges] = useState('def');
    const [checkedLoc, setCheckedLoc] = useState(locations);
    const [checkedAttrib, setCheckedAttrib] = useState(attribs);
    const [checkedField, setCheckedField] = useState(fields);
    const [checkedDeal, setCheckedDeal] = useState(deals);
    const [checkedGrade, setCheckedGrade] = useState(grades);
    const [daterange, setDateRange] = useState({});
    const [keyword, setKeyword] = useState('username');
    const [q, setQ] = useState('');

    useEffect(() => {
        setFilters({
            main_address: checkedLoc.join(','),
            category: checkedAttrib.join(','),
            company_type: checkedField.join(','),
            transaction_type: checkedDeal.join(','),
            membership_level: checkedGrade.join(','),
            startDate: daterange.startdate? moment(daterange.startdate).format('YYYY-MM-DD 00:00:00'): '',
            endDate: daterange.enddate? moment(daterange.enddate).format('YYYY-MM-DD 23:59:59'): '',
            keyword: keyword,
            q: q,
        });
    }, [checkedLoc, checkedAttrib, checkedField, checkedDeal, checkedGrade, daterange, keyword, q]);

    return (
        <div style={boxStyle}>
            <MenuFilter title={'지역'} items={locations} checkedItems={checkedLoc} setCheckedItems={setCheckedLoc} />
            <MenuFilter title={'회원구분'} items={attribs} checkedItems={checkedAttrib} setCheckedItems={setCheckedAttrib} />
            <MenuFilter title={'업체분류'} items={fields} checkedItems={checkedField} setCheckedItems={setCheckedField} />
            <MenuFilter title={'거래유형'} items={deals} checkedItems={checkedDeal} setCheckedItems={setCheckedDeal} />
            <MenuFilter title={'회원등급'} items={grades} checkedItems={checkedGrade} setCheckedItems={setCheckedGrade} />
            <Stack direction="row" spacing={8}>
                <div style={menuStyle}>
                    <h5 style={{ width: '5rem', minWidth: '4rem' }}>가입일자</h5>
                    <DatesPicker daterange={daterange} setDateRange={setDateRange} ranges={ranges} size='small' />
                </div>
                <div style={menuStyle}>
                    <h5 style={{ width: '4rem' }}>검색</h5>
                    <Select
                        labelId="target-select-label"
                        id="target-select"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        sx={{ minWidth: 120 }}
                        size='small' >
                            <MenuItem value="username">회원 ID</MenuItem>
                            <MenuItem value="name">이름</MenuItem>
                            <MenuItem value="com_name">업체명</MenuItem>
                    </Select>
                    <TextField
                        value={q}
                        label='검색어'
                        id='search'
                        onChange={(e) => setQ(e.target.value)}
                        placeholder='검색어를 입력해주세요'
                        size='small'
                        sx={{ minWidth: 200, marginLeft: '1rem' }}
                    />
                    <Button variant="contained" onClick={() => setReload(reload => reload+1)} sx={{ marginLeft: '1rem' }}>검색</Button>
                </div>
            </Stack>
        </div>
    )
}

export default MenuMember